import { render } from "./shutdownRecord.vue?vue&type=template&id=3b6b6f0e&scoped=true"
import script from "./shutdownRecord.vue?vue&type=script&lang=js"
export * from "./shutdownRecord.vue?vue&type=script&lang=js"

import "./shutdownRecord.vue?vue&type=style&index=0&id=3b6b6f0e&scoped=true&lang=css"
import "./shutdownRecord.vue?vue&type=style&index=1&id=3b6b6f0e&lang=css"
script.render = render
script.__scopeId = "data-v-3b6b6f0e"

export default script